class Utils {
    static createUniqueKey(length) {
        let uniqueX = '';
        for (let i = 0; i < length; i += 1) {
            uniqueX += 'x';
        }

        return (`${uniqueX}yx`).replace(/[xy]/g, (c) => {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    static getVideoIdByYouTube(url) {
        let videoId = '';
        // const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)
        // |(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url.match(regExp);
        if (match && match[7].length === 11) {
            videoId = match[7];
        }
        return videoId;
    }

    static getClipNoByNaver(url) {
        let clipNo = '';
        const regExp = /^.*(tv.naver.com\/v\/)([a-zA-Z0-9]*)/;
        const match = url.match(regExp);
        if (match) {
            clipNo = match[2];
        }
        return clipNo;
    }

    static getLang(key = '') {
        const keySet = key.split('.');
        const lang = window.Lang;

        if (lang && keySet.length > 0) {
            let langData = lang;
            const isFindLang = keySet.every((langKey) => {
                if (langKey in langData) {
                    langData = langData[langKey];
                    return true;
                }

                langData = '';
                return false;
            });

            if (isFindLang) {
                return langData;
            }
        }

        return key;
    }

    // string format by c style
    static format(fmtstr, args) {
        return fmtstr.replace(/\{(\d+)\}/g, (match, index) => args[index]);
    }

    static zeroFill(num, len) {
        var text = String(num);
        var textLen = text.length;
        for(; textLen < len; textLen++) {
            text = '0' + text;
        }
        return text;
    }

    // Fisher–Yates shuffle
    static shuffleArray(items) {
        let i;
        let t;
        let j;
        for (i = items.length - 1; i > 0; i -= 1) {
            t = items[i];
            j = Math.floor(Math.random() * (i + 1));
            items[i] = items[j];
            items[j] = t;
        }
        return items;
    }

    static hasSpecialCharacter(value) {
        return /!|@|#|\$|%|\^|&|\*|\(|\)|\+|=|-|\[|\]|\\|\'|;|,|\.|\/|{|}|\||\"|:|<|>|\?/g.test(value);
    }
}


export default Utils;



// WEBPACK FOOTER //
// ./sources/Utils.js